const Footer = () => {
    return (
        <footer>
            <p>Created by <a href="https://www.linkedin.com/in/koki-vasileski/" target="_blank" rel="noreferrer"> Koki</a>,  <a href="https://www.linkedin.com/in/mackenziemcclemont/" target="_blank" rel="noreferrer"> Mackenzie</a>,  <a href="https://heyitswillw.com/" target="_blank" rel="noreferrer"> William</a></p>
            <p className="footer">Created at <a href="https://junocollege.com/" target="_blank" rel="noreferrer"> Juno College</a></p>
        </footer>
    )
}

export default Footer